import request from './.request'
/*
 * 地块api - 补充
 * 获取园区下所有地块
 * */
export function getLandInPark(parkId) {
  return request({
    url: `/land/${parkId}?by=park`,
    method: 'get',
  })
}

export function getLandDetail(landId) {
  return request({
    url: `/land/${landId}`,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/land2.js